import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export default function ScheduleViewDialog({ open, onClose, data }) {
  const [info, setInfo] = useState({});
  const [recurrenceLabel, setRecurrenceLabel] = useState("");
  const [formattedTime, setFormattedTime] = useState("");

  useEffect(() => {
    if (!data) return;

    let obj = { ...data };

    // Remove default time from date strings
    if (obj.StartDate)
      obj.StartDate = obj.StartDate.replace("T00:00:00", "");

    if (obj.EndDate)
      obj.EndDate = obj.EndDate.replace("T00:00:00", "");

    if (obj.NextRecurrenceDate)
      obj.NextRecurrenceDate = obj.NextRecurrenceDate.replace("T00:00:00", "");

    // Build human-readable recurrence label
    if (obj.RecurrencePattern === "Monthly") {
      setRecurrenceLabel(`Day ${obj.RecurrencePatternDetails} of every Month`);
    } else if (obj.RecurrencePattern === "Weekly") {
      const dayMap = {
        Mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
        Sun: "Sunday"
      };
      setRecurrenceLabel(`${dayMap[obj.RecurrencePatternDetails]} of every Week`);
    } else if (obj.RecurrencePattern === "Daily") {
      setRecurrenceLabel(obj.RecurrencePatternDetails);
    }

    setFormattedTime(formatTime(obj.SendReportTime));
    setInfo(obj);
  }, [data]);

  const handleDialogClose = (event, reason) => {
    // Prevent closing when clicking on backdrop
    if (reason === 'backdropClick') return;
    if (onClose) onClose();
  };

  // Helper function to convert 24-hour time to 12-hour AM/PM format
  const formatTime = (time) => {
    if (!time) return "";

    const match = time
      .toString()
      .match(/^([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/);

    if (!match) return time;

    let hour = parseInt(match[1], 10);
    let min = match[2];
    let ampm = hour < 12 ? "AM" : "PM";

    hour = hour % 12 || 12;

    return `${hour}:${min} ${ampm}`;
  };

  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, position: 'relative' }}>
        View Schedule
        <IconButton
          aria-label="close"
          onClick={() => onClose && onClose()}
          sx={{ position: 'absolute', right: 8, top: 8 }}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 1 }}>
          <Typography fontWeight={600}>Time Zone:</Typography>
          <Typography>{info.Timezone}</Typography>
        </Box>

        <Box sx={{ mb: 1, display: "flex", gap: 4 }}>
          <Box>
            <Typography fontWeight={600}>Start Date:</Typography>
            <Typography>{info.StartDate}</Typography>
          </Box>
          <Box>
            <Typography fontWeight={600}>End Date:</Typography>
            <Typography>{info.EndDate}</Typography>
          </Box>
        </Box>

        <Box sx={{ mb: 1, display: "flex", gap: 4 }}>
          <Box>
            <Typography fontWeight={600}>Frequency:</Typography>
            <Typography>{info.RecurrencePattern}</Typography>
          </Box>
          <Box>
            <Typography fontWeight={600}>Day:</Typography>
            <Typography>{recurrenceLabel}</Typography>
          </Box>
        </Box>

        <Box sx={{ mb: 1 }}>
          <Typography fontWeight={600}>Send Time:</Typography>
          <Typography>{formattedTime}</Typography>
        </Box>

        <Box sx={{ mb: 1 }}>
          <Typography fontWeight={600}>Next Recurrence Date:</Typography>
          <Typography>{info.NextRecurrenceDate}</Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
